export default "__VITE_ASSET__uILI4Ko5__"